"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const paths_1 = require("../../paths");
const insuranceCertificate_class_1 = __importDefault(require("../insuranceCertificate.class"));
class InsuranceCoveragePurchasePendingPayment {
    constructor(certificate, insureLoadId, quoteId) {
        this.certificate = certificate;
        this.insureLoadId = insureLoadId;
        this.quoteId = quoteId;
    }
    static fromObj(data) {
        return new InsuranceCoveragePurchasePendingPayment(insuranceCertificate_class_1.default.fromObj(data.certificate), data.insureLoadId, data.quoteId);
    }
    purchasePendingId(playground) {
        const docId = encodeURI(this.certificate.shipment.freightId);
        const partnerId = playground ? "@PLAYGROUND" : this.certificate.partner.id;
        const parts = [partnerId, this.certificate.user.email, docId];
        const idString = parts.join("/");
        return encodeURI(idString);
    }
    getDocPath(playground) {
        const partnerId = playground ? "@PLAYGROUND" : this.certificate.partner.id;
        const userEmail = this.certificate.user.email;
        const docId = encodeURI(this.certificate.shipment.freightId);
        return paths_1.insurancePurchasePendingPaymentPath(partnerId, userEmail, docId);
    }
    static getPurchaseRequestDocPathParts(purchaseRequestId) {
        const [partnerId, email, docId] = purchaseRequestId.split("/");
        return {
            partnerId,
            email,
            docId
        };
    }
    static getPurchaseRequestDocPath(purchaseRequestId) {
        const { partnerId, email, docId } = InsuranceCoveragePurchasePendingPayment.getPurchaseRequestDocPathParts(purchaseRequestId);
        if (!partnerId || !email || !docId) {
            throw new Error("Invalid purchaseRequestId id");
        }
        return paths_1.insurancePurchasePendingPaymentPath(partnerId, email, docId, true);
    }
    static isPlayground(purchaseRequestId) {
        const { partnerId } = InsuranceCoveragePurchasePendingPayment.getPurchaseRequestDocPathParts(purchaseRequestId);
        return partnerId === "@PLAYGROUND";
    }
}
exports.default = InsuranceCoveragePurchasePendingPayment;
//# sourceMappingURL=insuranceCoveragePurchasePendingPayment.class.js.map